<template>
	<div class="w1200 flex myinfo">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1">
			<div class="flex benben-flex-layout flex-wrap align-center myinfo_2">
				<div>{{$t('收货地址')}}</div>
				<div class="flex benben-flex-layout flex-wrap align-center pointer addresList_1" @click="caozuo(1)">
					<img class="addresList_2" src="https://api.ezlunch.club/pc/image/34.png" alt="" srcset="">
					<div class="addresList_3">{{$t('新增地址')}}</div>
				</div>
			</div>
			<div v-loading="loading"  :element-loading-text="$t('拼命加载中')">
			
				
				 <!--  -->
				<el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerCell" :cell-style="{ textAlign: 'center' }">
				    <el-table-column prop="real_name" :label="$t('收货人')">
						<template slot-scope="scope">
							<div class="" >{{scope.row.real_name}}（{{scope.row.sex == 1 ? $t('先生') : $t('女士')}}）</div>
						</template>
					</el-table-column>
				    <el-table-column prop="mobile" :label="$t('联系方式')"></el-table-column>
				    <el-table-column prop="address" :label="$t('地址')">
						<template slot-scope="scope">
							<div class="addresList_5_1 pointer">{{scope.row.address}}{{scope.row.detail}}</div>
						</template>
						
					</el-table-column>
					
				    <el-table-column prop="address" :label="$t('操作')">
						<template slot-scope="scope">
							<div class="flex flex-wrap align-center justify-center benben-flex-layout addresList_4_4">
								<div class="addresList_5_1 pointer" @click="caozuo(2,scope.row)">{{$t('编辑')}}</div>
								<div class="addresList_5_2"></div>
								<el-popconfirm
								  :title="$t('确定要删除该地址吗？')"
								  :confirm-button-text="$t('确定')"
								  :cancel-button-text="$t('取消')"
								  @confirm="queding(scope.row)"
								>
								  <el-button slot="reference" class="foot_5">
									  <div class="addresList_5_3 pointer">{{$t('删除')}}</div>
								  </el-button>
								</el-popconfirm>
								
							</div>
						</template>
					</el-table-column>
				    <el-table-column prop="address" label="">
						<template slot-scope="scope">
							<div class="flex flex-wrap align-center justify-center benben-flex-layout">
								<div class="addresList_5_4 pointer" v-if="scope.row.is_default == 1">{{$t('默认地址')}}</div>
								<div class="addresList_5_5 pointer" v-else>{{$t('设置默认地址')}}</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: center;padding: 40px 0;" v-if="tableData.length == 0">
					<img style="width: 217px;height: 177px;" src="https://api.ezlunch.club/pc/image/29.png" alt="" srcset="">
				</div>
				<div v-if="tableData.length > 0" style="text-align: center;margin: 20px  0;">
					<el-pagination
					   @current-change="handleCurrentChange"
					   layout="prev, pager, next"
					   :current-page.sync="page" :page-size="page_size"
					   :total="total">
					 </el-pagination>
				</div>
			</div>
			
			<el-dialog class="footer_6" title="" :visible.sync="visible1" width="460px" >
				<div class="choiceFood_9">
					<div class="flex align-center justify-between benben-flex-layout choiceFood_9_1">
						<div class="choiceFood_9_2">{{$t('提示')}}</div>
					</div>
					<div class="flex flex-direction align-center benben-flex-layout addresList_6">
						<img class="addresList_6_1" src="https://api.ezlunch.club/pc/image/38.png" alt="" srcset="">
						<div class="addresList_6_2">{{$t('确定要删除该地址吗')}}</div>
						<div class="flex">
							<div class="addresList_6_3 pointer">{{$t('取消')}}</div>
							<div class="addresList_6_4 pointer">{{$t('确认')}}</div>
						</div>
					</div>
					
				</div>
			</el-dialog>
		</div>
		
	</div>
</template>

<script>
	import ChoiceMenu from "../components/choiceMenu.vue"
	export default {
		components: {
			ChoiceMenu
		},
		data() {
			return {
				total:0,
				page:1,
				page_size:10,
				loading:true,
			    headerCell: {
			    	'background-color': '#F2F3F5',
			    	'text-align': 'center',
			    },
				 tableData: [],
				visible1:false,
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post636f7683cf195()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post636f7683cf195()
			},
			// 切换页面
			handleCurrentChange(val){
				this.page = val
				this.post636f7683cf195()
			},
			// 地址列表
			post636f7683cf195(){
				this.$api.post(this.$apiUrls.post636f7683cf195,{page:this.page,list_rows:this.page_size}).then((res) => {
					if(res.code == 1){
						this.tableData = res.data.data
						this.total = res.data.total
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 确定删除
			queding(item){
				
				this.$api.post(this.$apiUrls.post636f773e8d763,{address_id:item.aid}).then((res) => {
					if(res.code == 1){
						this.post636f7683cf195()
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type,item){
				let url = ''
				if(type == 1){ //添加地址
					url = 'addresDetal'
				}else if(type == 2){ //编辑地址
				    url = 'addresDetal'
					console.log(item,'参数信息')
					window.sessionStorage.setItem('address_id', item.aid);
				}
				this.$router.push({
					name: url,
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.el-loading-spinner{
			top: 30%;
		}
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
		.footer_6{
			.el-dialog__header{
				display: none;
			}
			.el-dialog__body{
				padding: 0 !important;
				border-radius: 16px 16px 16px 16px;
				// background: rgba(187,195,211,0) !important;
			}
		}
		.foot_5{
			padding: 0;
			margin: 0;
			border: none;
		}
		.foot_5 span{
			display: flex;
		}
		.foot_5:hover {
			// background: #fff;
		}
	}
	.myinfo{
		margin-top: 20px;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.myinfo_2{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin: 0 0 16px 0;
	}
	.addresList_1{
		margin: 0 0 0 auto;
	}
	.addresList_2{
		width: 20px;
		height: 20px;
		margin: 0 6px 0 0;
	}
	.addresList_3{
		color: #199DFF;
	}
	.addresList_4{
		height: 48px;
		background: #F8F8FA;
		border-radius: 0px 0px 0px 0px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		line-height: 48px;
	}
	.addresList_4_1{
		width: 114px;
		text-align: center;
	}
	.addresList_4_2{
		width: 216px;
		text-align: center;
	}
	.addresList_4_3{
		width: 212px;
		text-align: center;
	}
	.addresList_4_4{
		width: 120px;
		text-align: center;
		margin: 0 32px;
	}
	.addresList_5{
		padding: 16px 0;
	}
	.addresList_5:nth-child(3n){
		background: #F8F8FA;
	}
	.addresList_5_1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.addresList_5_2{
		margin: 0 10px;
		height: 14px;
		border: 1px solid #999999;
	}
	.addresList_5_3{
		font-weight: 400;
		font-size: 14px;
		color: #FF4B4D;
	}
	.addresList_5_4{
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #FF770F;
		height: 32px;
		font-weight: 400;
		font-size: 14px;
		color: #FF770F;
		line-height: 32px;
		padding:0 20px;
		margin: 0 0 0 32px;
	}
	.addresList_5_5{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 0 0 0 32px;
	}
	.choiceFood_9{
		width: 560px;
		// height: 573px;
		padding: 0 0 40px 0;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
	}
	.choiceFood_9_1{
		width: 100%;
		height: 56px;
		background: #F3F3F3;
		border-radius: 8px 8px 0px 0px;
		padding: 0 20px;
	}
	.choiceFood_9_2{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.addresList_6{
		margin: 24px 0 0 0;
	}
	.addresList_6_1{
		width: 54px;
		height: 54px;
		margin: 0 0 14px 0;
	}
	.addresList_6_2{
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		margin: 0 0 24px 0;
	}
	.addresList_6_3{
		width: 77px;
		height: 36px;
		background: #F2F2F2;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.addresList_6_4{
		width: 77px;
		height: 36px;
		background: #FF770F;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		margin: 0 0 0 16px;
	}
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
</style>